module.exports = require("playwright-core");